import { createAsync, query, A, revalidate } from "@solidjs/router";
import { createEffect, createSignal, For, Show } from "solid-js";
import { formattedTimestamp, verifyUser } from "~/lib";

const getApplyingUsers = query( async () => {
	const { runRecordByStatusQueryServer } = await import( "~/_server/dynamoQueries" );

	return await runRecordByStatusQueryServer( "USER", "applying" );
}, "getApplyingUsers" );

export const Verify = ( props: any ) => {
	const applyingUsers = createAsync( () => getApplyingUsers(), { deferStream: true } );

	return (
		<div class="white-box space-y-4">
			<h1 class="text-xl font-bold mb-4">Verification</h1>

			<table class="w-full divide-y divide-gray-300">
				<tbody class="divide-y divide-gray-200 bg-white">

					<For each={applyingUsers()?.items.sort( ( a, b ) => b.registered - a.registered )}>
						{user => (
							<tr>
								<td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-0">
									{formattedTimestamp( user.registered, {	day: "2-digit",	month: "short",	year: "2-digit" } )}
								</td>
								<td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-0">
									<A href={`/dashboard/admin/users/${user.userId}`} class="text-indigo-600 hover:text-indigo-900">{user.name}</A>
									<br/><span class="text-gray-500 text-md">{user.address.company}</span>
								</td>
								<td class="py-4 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-0">
									<VerifyButton userId={user.userId} onVerified={() => revalidate( 'getApplyingUsers' )} />
								</td>
							</tr>
						)}
					</For>
				</tbody>
			</table>
		</div>
	);
}


export const VerifyButton = ( props: any ) => {
	const [running, setRunning] = createSignal<boolean>( false );

	const verify = async () => {
		setRunning( true );

		const r = await verifyUser( props.userId );

		setRunning( false );

		if ( r ) props.onVerified?.();
	}

	return (
		<button onClick={verify}
			disabled={running()}
			type="button"
			class="rias flex items-center bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500  focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed">
			Verify
			<Show when={running()}>
				<svg class="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
					<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
				</svg>
			</Show>
		</button>
	);
}